export default {
  setFinanceApplicationDetails(state, { application }) {
    state.application = application
  },
  reset(state) {
    state.application = null
  },
}
